<template>
    <div style="height: 100%;">
            <AdminDashboard hide-logo=true :dashboardVisible="dashboardVisible" @onChangeVisibility="onchangeDashboardVisibility"  :isModal="true" />
        <el-dropdown @command="handleCommand">
            <div class="dropdown-content">
                <div class="profile-icon">
                    <el-avatar :size="35"> <span class="first-letter">{{this.profile.firstName.charAt(0).toUpperCase()}}</span> </el-avatar>
                </div>
                <!-- <div class="username">
                    {{profile.firstName}}
                </div> -->
                <!-- <div class="down-arrow">
                    <IconBase
                        :width="24"
                        :height="24"
                        :fill="'#E7E6FA'"
                    >
                        <IconDownArrow />
                    </IconBase>
                </div> -->
            </div>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="DASHBOARD">Admin</el-dropdown-item>
                <el-dropdown-item command="CHANGEPASSWORD">Change password</el-dropdown-item>
                <el-dropdown-item command="LOGOUT">Logout</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        <Password/>
    </div>
</template>

<script>
import AdminDashboard from "../../authentication/AdminDashboard";
import Password from "../../authentication/Password";
import {
    mapState,
} from 'vuex';
import { showMessage } from "../../utils";
import { Auth } from "aws-amplify";
// import IconBase from '../IconBase'
// import IconDownArrow from '../icons/IconDownArrow'
import IconProfile from '../icons/IconProfile'

export default {
    name: "Profile",
    components: {
        AdminDashboard,
        Password,
        // IconBase,
        // IconDownArrow,
        // eslint-disable-next-line vue/no-unused-components
        IconProfile
    },
    data() {
        return {
            dashboardVisible: false,
        }
    },
    methods:{
        handleCommand(command){
            switch(command){
                case 'DASHBOARD':
                    this.showDashboard()
                    break;
                case 'CHANGEPASSWORD':
                    this.changePassword()
                    break;
                case 'LOGOUT':
                    this.logout()
                    break;
            }
        },
        onchangeDashboardVisibility(isVisible){
            this.dashboardVisible = isVisible;
        },
        showDashboard(){
            this.dashboardVisible = true
        },
        async logout(){
            try {
                await Auth.signOut();
                localStorage.removeItem('user')
                    this.$store.commit('user/setTokens', null);
                    this.$store.dispatch('user/getControls',this.mainRoom.name);
                    showMessage("Successfully logged out",'success')
            } catch (error) {
                showMessage("Unable to log out",'error')
            }
        },
        changePassword(){
            this.$store.commit('user/setChangePassword', true);
        }
    },
    computed:{
        ...mapState({
            profile: state => state.user.profile,
            mainRoom: state => state.rooms.mainRoom
        })
    }
};
</script>

<style scoped>

.first-letter{
    color: black;
    font-size: 18px;
    font-weight: bold;
}
>>>.el-dropdown{
    position: relative;
    color: #E7E6FA;
    font-size: 14px;
    line-height: 18px;
    width: 100%;
    height: 100%;
    padding: 0;
    cursor: pointer;
}
.dropdown-content {
    padding: 0 20px;
    height: 100%;
    align-items: center;
    position: relative;
}
.down-arrow {
    position: absolute;
    right: 0;
    top: 25%;
}
.profile-icon {
    position: absolute;
    left: 5%;
    top: 15%;
}
.username {
    text-align: left;
    padding: 13px 15px;
    width: 70%;
    margin: 0 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.el-dialog.admin-dashboard-dialog .el-dialog__header,.el-dialog.admin-dashboard-dialog .el-dialog__body{
    padding:0px;
}
</style>
